var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pt-4"},[_c('a',{attrs:{"href":"/settings-v2/api"}},[_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v(_vm._s(_vm.$t('settings.integration.custom-apis.configure')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }